import { render, staticRenderFns } from "./InfoFeatures.vue?vue&type=template&id=a13fb49c"
import script from "./InfoFeatures.vue?vue&type=script&lang=js"
export * from "./InfoFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports